import { el, setAttr } from 'redom';

import application from 'application';

import { stringToSVG } from 'utilities';

import {
  normalizeValue,
  isValidHexCode,
  isValidVariable,
  variableToCSSVariable,
  isValidCSSVariable,
  variableToHexCode,
  getPrefix,
  hexCodeToVariable
} from './utilities';

import dialogCloneButtonIconString from 'assets/images/dialog-close-button-icon.svg?raw';

import './index.scss';

const dialogCloneButtonIcon = stringToSVG(dialogCloneButtonIconString);

class PrefixedInput {

  constructor({ value, onChange }) {

    this.value = normalizeValue(value || '');
    this.onChange = onChange;

    this.input = el('input.prefixed-input', {
      value: this.value,
      oninput: this.handleChange.bind(this),
      placeholder: 'FFFFFF',
    });
    this.button = el('button.clear-color-picker-value-button', {
      onclick: this.handleClear.bind(this)
    }, [
      dialogCloneButtonIcon.cloneNode(true)
    ]);

    this.el = el('.prefixed-input-container-main', [
      el('span.prefix', getPrefix(this.value)),
      this.input,
      this.button
    ]);

  }

  handleClear(event) {

    event.stopPropagation();

    this.onChange('');

    this.input.value = '';

  }

  setValue(value) {

    this.value = normalizeValue(value);

    const variable = hexCodeToVariable(application, value);

    if (variable !== null) {
      this.value = variable;
    }

    this.input.value = this.value;
    this.el.querySelector('.prefix').textContent = getPrefix(this.value);

  }

  handleChange(e) {

    const value = e.target.value.trim();
    const val = value.replace('#', '');
    console.log({ value, val });
    e.target.value = val;

    if (isValidHexCode(val)) {
      this.onChange('#' + val);
    } else if (isValidVariable(val)) {
      this.onChange(variableToCSSVariable(val));
    } else if (val) {
      this.el.classList.add('error');
    } else {
      this.el.classList.remove('error');
    }

  }

  focus() {

    this.input.focus();

  }

}

PrefixedInput.tryConvertToHexCode = function tryConvertToHexCode(color) {

  if (color === '') {
    return color;
  }

  if (color === null) {
    return '';
  }

  if (isValidCSSVariable(color) === false) {
    return color;
  }

  return variableToHexCode(application, color);

};

export default PrefixedInput;